import React from "react";

import { HeaderGroup } from "@tanstack/react-table";

import { DataTableDataType } from "..";
import { ColumnHeader } from "./ColumnHeader";

type TableHeaderProps = {
  headers: HeaderGroup<DataTableDataType>[];
};

export const TableHeader: React.FC<TableHeaderProps> = ({ headers }) => {
  return (
    <thead className="sticky top-0 z-9 bg-white">
      {headers.map((headerGroup) => (
        <tr
          key={headerGroup.id}
          className="border-grey3 h-12 w-fit border-b bg-white"
        >
          {headerGroup.headers.map((header) => (
            <ColumnHeader
              key={`${header.id}_${header.index}`}
              {...{ header }}
            />
          ))}
        </tr>
      ))}
    </thead>
  );
};
